import React from 'react';

import Container from '@mui/material/Container';


const Terminos = () => {
    return (
        <Container maxWidth="lg">
            <h1>Terminos y condiciones</h1>
        </Container>
    );
};

export default Terminos;